import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../../chunks/tslib.es6.js";
import "../../../core/Logger.js";
import "../../../core/accessorSupport/ensureType.js";
import "../../../core/arrayUtils.js";
import "../../../core/has.js";
import "../../../core/accessorSupport/set.js";
import { subclass as r } from "../../../core/accessorSupport/decorators/subclass.js";
import { isWidget as t, hasDomNode as o } from "../../support/widget.js";
import { tsx as s } from "../../support/jsxFactory.js";

var i = function i(_i2) {
  var c = /*#__PURE__*/function (_i) {
    _inherits(c, _i);

    var _super = _createSuper(c);

    function c() {
      var _this;

      _classCallCheck(this, c);

      _this = _super.apply(this, arguments), _this.renderNodeContent = function (e) {
        return t(e) && !e.destroyed ? s("div", {
          key: e
        }, e.render()) : e instanceof HTMLElement ? s("div", {
          key: e,
          bind: e,
          afterCreate: _this._attachToNode
        }) : o(e) ? s("div", {
          key: e,
          bind: e.domNode,
          afterCreate: _this._attachToNode
        }) : null;
      };
      return _this;
    }

    _createClass(c, [{
      key: "_attachToNode",
      value: function _attachToNode(e) {
        var r = this;
        e.appendChild(r);
      }
    }]);

    return c;
  }(_i2);

  return c = e([r("esri.widgets.Feature.ContentMixin")], c), c;
};

export { i as FeatureContentMixin };